var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { "is-disabled": _vm.isDisabled },
      attrs: { "data-component": "base-settings-table" },
    },
    [
      _c(
        "div",
        { staticClass: "table-header" },
        [
          _vm._l(_vm.columns, function (column) {
            return _c(
              "div",
              {
                key: column.key,
                staticClass: "table-header-column",
                style: _vm.getColumnStyle(column),
              },
              [
                _c("div", { staticClass: "column-title" }, [
                  _vm._v("\n        " + _vm._s(column.label) + "\n      "),
                ]),
              ]
            )
          }),
          _vm._v(" "),
          _vm.canReorder
            ? _c("div", { staticClass: "table-header-placeholder" })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-body" },
        [
          _vm.useVScroll
            ? _c("base-virtual-scroll", {
                attrs: { "data-key": _vm.dataKey, items: _vm.items },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var index = ref.index
                        var data = ref.data
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "table-row",
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("item-click", {
                                    index: index,
                                    props: data,
                                    items: _vm.items,
                                  })
                                },
                              },
                            },
                            [
                              _vm._t("item", null, {
                                index: index,
                                props: data,
                                items: _vm.items,
                              }),
                            ],
                            2
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            : _c("base-sortable-list", {
                attrs: {
                  list: _vm.items,
                  "is-reordable": _vm.canReorder,
                  "is-disabled": _vm.isDisabled,
                  handle: "[data-drag]",
                },
                on: {
                  scroll: _vm.onScroll,
                  update: function ($event) {
                    return _vm.$emit("items-order-change", $event)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item",
                      fn: function (props) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "table-row",
                              on: {
                                click: function ($event) {
                                  return _vm.onItemClick($event, props)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "table-row-content" },
                                [_vm._t("item", null, null, props)],
                                2
                              ),
                              _vm._v(" "),
                              _vm.canReorder
                                ? _c(
                                    "div",
                                    {
                                      class: { "is-disabled": _vm.isDisabled },
                                      attrs: { "data-drag": "drag-handle" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                        },
                                      },
                                    },
                                    [
                                      _c("or-icon", {
                                        attrs: { icon: "drag_indicator" },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "footer",
                      fn: function (props) {
                        return [_vm._t("table-footer", null, null, props)]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }